import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import OutboundMarketingPage from '../settings/outbounds/Index.vue';
import CampaignDetailPage from './pages/CampaignDetailPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
  // ACESSO-01 (L8b): as campanhas (`campaigns#create`, `#update`, `#destroy`), travado: o super admin. A nova é o
  // wizard do Outbound, que dispara pelo `outbounds:send`.
  escopos: ['campaigns:manage'],
  // Campaigns are hidden from tenant admins (only Super Admins manage them). Guard every child route,
  // not just the sidebar, so a client admin cannot deep-link into ongoing/one_off.
  superAdminOnly: true,
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        // Campanha nesta plataforma é WhatsApp. Live chat e SMS saíram em 21/09/2026: o live
        // chat depende do widget do site, que não é o produto, e SMS exige Twilio, que ninguém
        // da frota usa.
        //
        // WhatsApp e Outbound Marketing deixaram de ser duas entradas em 21/09/2026: as duas
        // sempre produziram o MESMO `Campaign` (a diferença é o `agent_bot_id` no
        // `additional_attributes`, que `Campaign#execute_campaign` lê para escolher a via), e
        // medindo a frota não havia UMA campanha criada pela tela nativa — as 10 existentes
        // vieram todas do wizard. A lista virou a raiz, o wizard virou "nova campanha", e toda
        // rota antiga redireciona para não matar link salvo e favorito em 404.
        {
          path: '',
          name: 'campaigns_index',
          meta,
          component: WhatsAppCampaignsPage,
        },
        {
          // Detalhe: quem recebeu, quem não, e por quê — mais o progresso ao vivo, que saiu do
          // wizard. `:campaignId` é o display_id, que é o que o JSON da campanha expõe como id.
          path: ':campaignId(\\d+)',
          name: 'campaigns_detail',
          meta,
          component: CampaignDetailPage,
        },
        {
          path: 'nova',
          name: 'campaigns_new',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.OUTBOUNDS,
            escopos: ['outbounds:send'],
          },
          component: OutboundMarketingPage,
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_index', params: to.params };
          },
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_index', params: to.params };
          },
        },
        {
          path: 'outbound',
          name: 'campaigns_outbound_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_new', params: to.params };
          },
        },
      ],
    },
  ],
};

export default campaignsRoutes;
